import qs from 'qs';
import { network } from 'services/network';

import { QueryParams } from 'api/queries/getStoredFilterBulkAssignToUser.query';

export const getStoredFilterBulkAssignToUser = ({ contractId }: QueryParams) => {
    const querystring = qs.stringify({ contractId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getStoredFilterBulkAssignToUser${querystring}`;
    return network.get(url).then((response) => {
        return response.data;
    });
};
